let share = function(shareConfig) {
    // 微信分享api
    let sharetitle = shareConfig.sharetitle;
    let sharelink = shareConfig.sharelink;
    let shareimgUrl = shareConfig.shareimgUrl;
    let sharedesc = shareConfig.sharedesc;

    $.ajax({
        url: '//api.cmpp.v.ifeng.com/api/Secert',
        type: 'get',
        dataType: 'jsonp',
        callback: 'wxshareCallback',
        data: {
            url: window.location.href,
            rt: 'jsonp'
        },
        success: function(msgCallback) {
            const msgData = msgCallback.data || {};
            wx.config({
                debug: false,
                appId: msgData.appId,
                timestamp: msgData.timestamp,
                nonceStr: msgData.nonceStr,
                signature: msgData.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo'
                    // 所有要调用的 API 都要加到这个列表中
                ]
            });
            wx.ready(function() {
                wx.checkJsApi({
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function(res) {
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        console.log(res);
                    }
                });

                wx.error(function(res) {
                    console.log(res);
                });
                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                wx.onMenuShareTimeline({
                    title: sharetitle, // 分享标题
                    link: sharelink, // 分享链接
                    imgUrl: shareimgUrl, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                    }
                });
                // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
                wx.onMenuShareAppMessage({
                    title: sharetitle, // 分享标题
                    desc: sharedesc, // 分享描述
                    link: sharelink, // 分享链接
                    imgUrl: shareimgUrl, // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function() {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                    }
                });
                // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
                wx.onMenuShareQQ({
                    title: sharetitle, // 分享标题
                    desc: sharedesc, // 分享描述
                    link: sharelink, // 分享链接
                    imgUrl: shareimgUrl, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        // alert(shareimgUrl);
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                    }
                });
                // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
                wx.onMenuShareWeibo({
                    title: sharetitle, // 分享标题
                    desc: sharedesc, // 分享描述
                    link: sharelink, // 分享链接
                    imgUrl: shareimgUrl, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                    }
                });

                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                wx.onMenuShareTimeline({
                    title: sharetitle, // 分享标题
                    link: sharelink, // 分享链接
                    imgUrl: shareimgUrl, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
    });
};

module.exports = share;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.weixin.share/index.js